export default "__VITE_ASSET__BAKxd8LN__"